import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./import-naming-section.scss";
import {UseState} from "../../../../../../../../react/use-state";
import {Invoke} from "../../../../../../../../react/invoke";
import {stateChangeNestedValue} from "../../../../../../../../react/state-change-nested-value";
import {ErrorHighlighter} from "../../../../../../../light/error-highlighter";
import {cx} from "emotion";
import {ImportEditingPanel} from "./import-editing-panel/import-editing-panel";
import {ImportViewingPanel} from "./import-viewing-panel/import-viewing-panel";

export const ImportNamingSection = ({defaultNames, next}) => cs(
    ["editing", (_, next) => UseState({next})],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["addAdditionalOptions", (_, next) => UseState({getInitValue: () => (["OR RESIDENT","OR OCCUPANT","OR HOMEOWNER"].indexOf(defaultNames.value.defaultName2) !== -1), next})],

    ({editing, eh, addAdditionalOptions}) => next({
        valid: !editing.value || !defaultNames.value.replaceName || !!defaultNames.value.defaultName,
        highlightErrors: () => {
            stateChangeNestedValue(editing, ["showErrors"], () => true);
            eh.start();
        },
        render: () => (
            <div className={cx("import-naming-section-4rp", eh.css)}>
                {Invoke({action: () => editing.onChange(null)})}

                {editing.value ? (
                    ImportEditingPanel({
                        data: defaultNames,
                        addAdditionalOptions,
                        showErrors: editing.value.showErrors,
                        onCancel: () => editing.onChange(null),
                    })
                ) : (
                    ImportViewingPanel({
                        onEdit: () => editing.onChange({}),
                    })
                )}
            </div>
        ),
    }),
);
